module.exports = __webpack_public_path__ + "static/media/ppt-yd2.35277bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/ppt-yd2.png
// module id = 2003
// module chunks = 6